import { VoucherLeftPanelSide } from 'app/src/features/Shopping/Direct/Voucher/components/VoucherLeftPanelSide'
import { VoucherRightPanelSide } from 'app/src/features/Shopping/Direct/Voucher/components/VoucherRightPanelSide'
import { VoucherWidget } from 'app/src/features/Shopping/Direct/Voucher/components/VoucherWidget'
import { shoppingApi } from 'app/src/services/welfareportal'
import { CheckCatalogButton, ErrorCancelPage, PortalConfirmDialog } from 'app/src/shared/components'
import { CancelSuccess } from 'app/src/shared/components/CancelSuccess'
import { Button } from 'primereact/button'
import { ProgressSpinner } from 'primereact/progressspinner'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export function VoucherDetails(props: { order: shoppingApi.OrderDetails; funnelMode?: boolean }) {
  const { t } = useTranslation('shopping', { keyPrefix: 'Direct.Voucher' })
  const [showUsageModal, setShowUsageModal] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const deleteOrder = shoppingApi.useOrderCancel()
  const [errorComponentVisible, setErrorComponentVisible] = useState(false)
  const [successComponentVisible, setSuccessComponentVisible] = useState(false)

  const orderDetailVoucher = props.order?.purchaseDetails as shoppingApi.OrderDetailsPurchaseVoucher

  const handleOrderCancellation = async () => {
    try {
      await deleteOrder.mutateAsync({
        pathParams: { orderId: props.order.orderId },
      })
      setShowModal(false)
      setSuccessComponentVisible(true)
    } catch (error) {
      setErrorComponentVisible(true)
      console.error('Failed to cancel order:', error)
    }
  }

  if (errorComponentVisible) {
    return (
      <ErrorCancelPage
        errorTitle={t('cancelOrder.cancelErrorMessage.title')}
        errorSubtitle={t('cancelOrder.cancelErrorMessage.subtitle')}
      >
        <div className='mx-auto flex justify-center'>
          <CheckCatalogButton />
        </div>
      </ErrorCancelPage>
    )
  }
  if (successComponentVisible) {
    return (
      <CancelSuccess
        successTitle={t('cancelOrder.cancelSuccessMessage.title')}
        successSubTitle={t('cancelOrder.cancelSuccessMessage.subtitle')}
      >
        <div className='mx-auto flex justify-center'>
          <CheckCatalogButton />
        </div>
      </CancelSuccess>
    )
  }
  if (deleteOrder.isPending)
    return (
      <ProgressSpinner
        data-testid='loading-element'
        pt={{
          root: {
            className: 'w-[50px] h-[50px]',
          },
        }}
      />
    )

  return (
    <div className='mx-auto max-w-5xl'>
      {(typeof props.funnelMode === 'undefined' || !props.funnelMode) && (
        <div className='noPrint'>
          <h1 className='welfareportal-titlecenter'>{t('detailPageTitle')}</h1>
          {props.order?.isCancelable && props.order?.status !== 'canceled' && (
            <div className='flex justify-end'>
              <Button link onClick={() => setShowModal(true)} icon='pi pi-trash' label={t('cancelOrder.cancelButtonLabel')} />
            </div>
          )}
          <div className='card grid grid-cols-1 divide-x-0 divide-y-2 p-5 lg:grid-cols-12 lg:divide-x-2 lg:divide-y-0'>
            <VoucherLeftPanelSide
              statusMode
              order={props.order}
              setShowUsageModal={setShowUsageModal}
              showUsageModal={showUsageModal}
            />
            <VoucherRightPanelSide order={props.order} />
          </div>
        </div>
      )}
      <VoucherWidget order={props.order} />
      {props.order?.status === 'canceled' || orderDetailVoucher?.voucherDetailsUrl ? (
        <></>
      ) : (
        <div className='mt-4 flex justify-center'>
          <Button
            role='link'
            rounded
            outlined
            onClick={() => window.print()}
            link={typeof props.funnelMode === 'undefined' || !props.funnelMode}
            text={typeof props.funnelMode === 'undefined' || !props.funnelMode}
            pt={{
              root: { className: typeof props.funnelMode === 'undefined' || !props.funnelMode ? 'underline' : undefined },
            }}
          >
            {t('getYourCodeButtonLabel')}
          </Button>
        </div>
      )}
      {typeof props.funnelMode !== 'undefined' && props.funnelMode && t('informativeBannerFunnelMode') && (
        <div dangerouslySetInnerHTML={{ __html: t('informativeBannerFunnelMode') }} />
      )}
      {(typeof props.funnelMode === 'undefined' || !props.funnelMode) && t('informativeBannerDetailsMode') && (
        <div dangerouslySetInnerHTML={{ __html: t('informativeBannerDetailsMode') }} />
      )}
      <div className='mx-auto flex justify-center'>
        <CheckCatalogButton />
      </div>
      {showModal && (
        <PortalConfirmDialog
          body={t('cancelOrder.body')}
          title={t('cancelOrder.title')}
          reject={() => setShowModal(false)}
          accept={handleOrderCancellation}
        />
      )}
    </div>
  )
}
